import ApiService from './ApiService';

class MarketDataService {
  async getMarketDataList() {
    try {
      const response = await ApiService.call('/secured/get_market_watch', 'GET');
      let data = response;

      return {
        marketDataList: data.marketDataList,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new MarketDataService();
